import React from 'react';

interface IProps {
  className?: string;
  formattedCuisineCategories: string | null | undefined;
}

export const CuisineListing: React.FC<IProps> = ({ className, formattedCuisineCategories }) => (
  <div className={`w-full truncate ${className}`}>
    <span className={`text-sm font-semibold leading-4 text-neutral-800`}>{formattedCuisineCategories}</span>
  </div>
);
